import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { getUserSession } from "../../../../core/util/core/Session";
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {

    const session = getUserSession();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    const path = '/emendations/';
    const paths = {
        endpointSave: config.endpoints.backend + 'emendations/save',
        endpointGetById: config.endpoints.backend + 'emendations/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllModalities: config.endpoints.backend + 'emendationmodalities/getall',
        endpointGetAllSituations: config.endpoints.backend + 'emendationsituations/getall',
        endpointGetAllGrantors: config.endpoints.backend + 'emendationgrantors/getall',
        endpointGetAllAuthors: config.endpoints.backend + 'emendationauthors/getall',
        endpointGetAllTypes: config.endpoints.backend + 'emendationtypes/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Emendas",
        labelTitleEdit: "Editar Emendas",
        labelTitleView: 'Visualizar Emendas'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                !hiddenValues.pdc_entity_id ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        values.projects = [{ project: '' }]
                        form.fields[2].autoFocus = true;
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'projects',
                    type: 'multiinput',
                    label: 'Projetos',
                    sortBy: 'index',
                    showDeleteButton: true,
                    form: [
                        {
                            name: 'pdc_project_id',
                            type: 'select',
                            label: 'Projeto',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllProjects,
                                label: 'project_name',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...profileFilter,
                                        pdc_entity_id: values.pdc_entity_id
                                    }
                                }
                            },
                            validations: {
                                required: false
                            }
                        },
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_emendation_modality_id',
                    type: 'select',
                    label: 'Modalidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllModalities,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 4,
                },
                {
                    name: 'pdc_emendation_situation_id',
                    type: 'select',
                    label: 'Situação',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllSituations,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 4,
                },
                {
                    name: 'pdc_emendation_type_id',
                    type: 'select',
                    label: 'Tipo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllTypes,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 4,
                },
                {
                    name: 'pdc_emendation_grantor_id',
                    type: 'select',
                    label: 'Concedente',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllGrantors,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'pdc_emendation_author_id',
                    type: 'select',
                    label: 'Autor',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllAuthors,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'emendation_number',
                    type: 'text',
                    label: 'Nº Emenda',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'instrument_number',
                    type: 'text',
                    label: 'Nº Instrumento',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'link',
                    type: 'text',
                    label: 'Link',
                    validations: {
                        required: false
                    },
                    maxLength: 255,
                    columnSize: 4
                },
                {
                    name: 'object',
                    type: 'text',
                    label: 'Objeto',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'start_validity',
                    type: 'date',
                    label: 'Início Vigência',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'end_validity',
                    type: 'date',
                    label: 'Fim Vigência',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'year',
                    type: 'year',
                    label: 'Ano',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'global_value',
                    type: 'decimal',
                    label: 'Valor Global',
                    validations: {
                        required: true
                    },
                    columnSize: 3
                },
                {
                    name: 'emendation_value',
                    type: 'decimal',
                    label: 'Valor Emenda',
                    validations: {
                        required: true
                    },
                    columnSize: 3
                },
                {
                    name: 'committed_value',
                    type: 'decimal',
                    label: 'Valor Empenhado',
                    validations: {
                        required: true
                    },
                    columnSize: 3
                },
                {
                    name: 'released_value',
                    type: 'decimal',
                    label: 'Valor Liberado',
                    validations: {
                        required: true
                    },
                    columnSize: 3
                },
                {
                    name: 'total_movement_value',
                    type: 'decimal',
                    label: 'Valor Total Movimentações',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'balance_value',
                    type: 'decimal',
                    label: 'Valor Saldo',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'returned_value',
                    type: 'decimal',
                    label: 'Valor Devolvido',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'files',
                    type: 'multiUploadFileS3',
                    label: 'Arquivos',
                    uploadPath: 'emendations',
                    extensionAccept: '.pdf',
                    limitFileSize: 25,
                    uploadFileLimit: 100,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
